'use client';

import Link from "next/link";


export default function Home() {
  return (
    <main className="min-h-screen bg-white text-neutral-900">
      {/* Top Nav */}
      <header className="border-b">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
          <div className="text-xl font-bold">
            <span className="text-indigo-600">Ad</span>Wisely
          </div>
          <nav className="hidden space-x-6 text-sm font-medium md:block">
            <a href="#features" className="hover:text-indigo-600">Features</a>
            <a href="#how" className="hover:text-indigo-600">How It Works</a>
            <a href="#contact" className="hover:text-indigo-600">Contact</a>
          </nav>
          <Link
            href="/connections"
            className="rounded-md bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-500"
          >
            Get Started
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="mx-auto max-w-6xl px-4 py-20 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          Run Winning Ads <span className="text-indigo-600">Without the Guesswork</span>
        </h1>
        <p className="mt-4 text-lg text-neutral-600">
          Connect your ad accounts, see plain‑English insights, and spend smarter.
        </p>
        <div className="mt-6 flex justify-center gap-4">
          <Link
            href="/connections"
            className="rounded-md bg-indigo-600 px-6 py-3 text-white hover:bg-indigo-500"
          >
            Start Free
          </Link>
          <a
            href="#how"
            className="rounded-md border px-6 py-3 hover:bg-neutral-100"
          >
            Learn More
          </a>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="bg-neutral-50 py-16">
        <div className="mx-auto max-w-6xl px-4">
          <h2 className="text-2xl font-bold text-center">Why AdWisely?</h2>
          <div className="mt-10 grid gap-8 md:grid-cols-3">
            <div className="rounded-lg bg-white p-6 shadow transition hover:shadow-md">
              <h3 className="text-lg font-semibold">Connect in Minutes</h3>
              <p className="mt-2 text-sm text-neutral-600">
                Securely link Meta, Google, Amazon—no spreadsheets.
              </p>
            </div>
            <div className="rounded-lg bg-white p-6 shadow transition hover:shadow-md">
              <h3 className="text-lg font-semibold">Daily Insights</h3>
              <p className="mt-2 text-sm text-neutral-600">
                Clear summaries on spend, CTR, ROAS, and wasted budget.
              </p>
            </div>
            <div className="rounded-lg bg-white p-6 shadow transition hover:shadow-md">
              <h3 className="text-lg font-semibold">Actionable Alerts</h3>
              <p className="mt-2 text-sm text-neutral-600">
                Catch problems early—pause or boost with confidence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how" className="py-16">
        <div className="mx-auto max-w-6xl px-4">
          <h2 className="text-2xl font-bold text-center">How It Works</h2>
          <div className="mt-10 grid gap-8 md:grid-cols-3">
            <div className="text-center">
              <div className="mb-3 text-4xl">🔗</div>
              <h3 className="font-semibold">1. Connect Accounts</h3>
              <p className="mt-2 text-sm text-neutral-600">OAuth to Meta, Google, Amazon.</p>
            </div>
            <div className="text-center">
              <div className="mb-3 text-4xl">📊</div>
              <h3 className="font-semibold">2. Get Insights</h3>
              <p className="mt-2 text-sm text-neutral-600">We analyse campaigns and surface what matters.</p>
            </div>
            <div className="text-center">
              <div className="mb-3 text-4xl">⚡</div>
              <h3 className="font-semibold">3. Take Action</h3>
              <p className="mt-2 text-sm text-neutral-600">Apply recommendations and improve results.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="border-t py-6 text-center text-sm text-neutral-500">
        © {new Date().getFullYear()} AdWisely. All rights reserved.
      </footer>
    </main>
  );
}
